import React from "react";
import Reveal from "@/components/Reveal";

const ROWS = [
    ["M (৪০)", '৪০"', '১৭.৫"', '৪০"', '২৪"'],
    ["L (৪২)", '৪২"', '১৮"', '৪২"', '২৪.৫"'],
    ["XL (৪৪)", '৪৪"', '১৮.৫"', '৪৪"', '২৫"'],
    ["XXL (৪৬)", '৪৬"', '১৯"', '৪৬"', '২৫.৫"'],
];


export default function SizeChart() {
    return (
        <section id="size-chart" className="bg-[#FBF9F5] py-10 md:py-16 scroll-mt-[4.25rem]">
            <div className="max-w-3xl mx-auto px-4 sm:px-6">
                <Reveal className="text-center mb-6 md:mb-8">
                    <h2 className="font-serif text-xl sm:text-3xl font-bold tracking-tight text-[#1E1B18]">
                        পাঞ্জাবি সাইজ চার্ট
                    </h2>
                    <p className="mt-2 text-sm sm:text-base text-[#5C554D]">
                        ✨ পরিপূর্ণ ফিট, প্রিমিয়াম কমফোর্ট ✨
                    </p>
                </Reveal>

                <Reveal delay={0.08}>
                    <div className="rounded-xl border border-[#E4DDD3] bg-white overflow-hidden shadow-sm" data-testid="size-chart-table">
                        {/* Table Header */}
                        <div className="grid grid-cols-5 bg-[#8B3E2B] text-[#FBF9F5]">
                            {["সাইজ", "বুক", "কাঁধ", "লম্বা", "হাতা"].map((h) => (
                                <div key={h} className="px-2 py-3 sm:py-3.5 text-center text-[11px] sm:text-sm font-bold tracking-wide">
                                    {h}
                                </div>
                            ))}
                        </div>
                        {/* Table Rows */}
                        {ROWS.map((row, i) => (
                            <div
                                key={row[0]}
                                className={`grid grid-cols-5 text-center transition-colors duration-150 ${
                                    i % 2 === 0 ? "bg-white" : "bg-[#F9F6F0]"
                                } hover:bg-[#FBEBE3]`}
                            >
                                {row.map((cell, ci) => (
                                    <div
                                        key={ci}
                                        className={`px-2 py-2.5 sm:py-3 text-[12px] sm:text-sm ${
                                            ci === 0
                                                ? "font-bold text-[#8B3E2B]"
                                                : "text-[#4A453F]"
                                        }`}
                                    >
                                        {cell}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </Reveal>
                {/* Footer Note */}
                <Reveal delay={0.18}>
                    <p className="mt-5 text-center text-[11px] sm:text-xs text-[#8A8278] leading-relaxed">
                        ✦ দ্রষ্টব্য: মাপগুলো ইঞ্চিতে দেওয়া হয়েছে এবং সামান্য তারতম্য হতে পারে (±০.৫ ইঞ্চি) ✦
                    </p>
                </Reveal>
            </div>
        </section>
    );
}